import { ILocation } from "@/services/locationApi";

export interface LocationCluster {
  id: string;
  lat: number;
  lng: number;
  count: number;
  locations: ILocation[];
}

function geoDistance(
  lat1: number, lng1: number,
  lat2: number, lng2: number,
): number {
  const R = 3959;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function buildLocationClusters(locations: ILocation[], radiusMiles = 40): LocationCluster[] {
  const valid = locations.filter(
    (l) => l.fieldData.latitude != null && l.fieldData.longitude != null,
  );

  const groups: { lat: number; lng: number; locs: ILocation[] }[] = [];

  for (const loc of valid) {
    let assigned = false;
    for (const group of groups) {
      if (
        geoDistance(loc.fieldData.latitude, loc.fieldData.longitude, group.lat, group.lng) <=
        radiusMiles
      ) {
        group.locs.push(loc);
        // Recalculate centroid as average of all members
        group.lat = group.locs.reduce((s, l) => s + l.fieldData.latitude, 0) / group.locs.length;
        group.lng = group.locs.reduce((s, l) => s + l.fieldData.longitude, 0) / group.locs.length;
        assigned = true;
        break;
      }
    }
    if (!assigned) {
      groups.push({
        lat: loc.fieldData.latitude,
        lng: loc.fieldData.longitude,
        locs: [loc],
      });
    }
  }

  return groups.map(({ lat, lng, locs }, i) => ({
    id: `cluster-${i}`,
    lat,
    lng,
    count: locs.length,
    locations: locs,
  }));
}
